import React, { useContext, useRef, useState } from 'react'
import {
    MultiPartFeatureContainer, FeatureBackground,
    DetailsLandscapeContainer, DetailsPortraitContainer, PartsContainer, ContentContainer,
    DetailsTitle, DetailsSubtitle, PartItemContainer, DetailsTitleAfterEffects, PartItemBackground, PartItemDetails, PartItemHeading, PartItemSubHeading, BlackFilterBackground, DetailsButton
} from './MultiPartCardStyle';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { mediaURL } from 'src/consumer/services';
import { PlayerContext } from 'src/consumer/context/PlayerContext';
import { resetPlayerData } from 'src/consumer/helpers/playerHelper';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const MultiPartCard = (props) => {

    const { setupData } = useContext(SetupContext);
    const { playerData, setPlayerData } = useContext(PlayerContext);
    const refToContainer = useRef();

    const { data } = props;

    let isMobile;
    const [isHovered, setIsHovered] = useState(false);
    if (setupData?.clientType === "desktopBrowser") {
        isMobile = false;
    } else {
        isMobile = true;
    }


    return (
        <MultiPartFeatureContainer
            ref={refToContainer}
            onMouseEnter={() => { setIsHovered(true) }}
            onMouseLeave={() => { setIsHovered(false) }}
            isMobile={isMobile}
        >

            <FeatureBackground src={mediaURL + data?.featureBackground} />

            <ContentContainer isMobile={isMobile}>

                {!isMobile &&
                    <DetailsLandscapeContainer isHovered={isHovered}>
                        <DetailsTitle>
                            {data?.title}
                        </DetailsTitle>
                        <DetailsSubtitle>
                            {data?.description}
                        </DetailsSubtitle>
                        <DetailsButton onClick={() => setIsHovered(true)} >
                            Start with the Series
                            <ArrowForwardIosIcon sx={{ fontSize: 25, color: 'white' }} />
                        </DetailsButton>
                    </DetailsLandscapeContainer>
                }

                {!isMobile &&
                    <DetailsTitleAfterEffects isHovered={isHovered}>
                        {data?.title}
                    </DetailsTitleAfterEffects>
                }

                {isMobile &&
                    <DetailsPortraitContainer>
                        <DetailsTitle isMobile={isMobile}>
                            {data?.title}
                        </DetailsTitle>
                        <DetailsSubtitle isMobile={isMobile}>
                            {data?.description}
                        </DetailsSubtitle>
                        {/* <DetailsButton>
                            Start with the Series
                            <ArrowForwardIosIcon sx={{ fontSize: 25, color: 'white' }} />
                        </DetailsButton> */}
                    </DetailsPortraitContainer>
                }

                <PartsContainer isHovered={isHovered} isMobile={isMobile}>

                    {data?.parts?.map((item, index) => {
                        return (
                            <PartItemContainer
                                key={index}
                                preselected={index === 0}
                                isHovered={isHovered}
                                isMobile={isMobile}
                                onClick={() => {
                                    if (item?.type === "course") {
                                        setPlayerData({
                                            ...resetPlayerData(playerData),
                                            showPlayer: true,
                                            selectedCard: playerData.showPIP ? playerData?.selectedCard : item?.allData,
                                            source: 'tile',
                                            id: 'multi-episode',
                                            otherData: {}
                                        })
                                    }

                                }}
                            >
                                <PartItemBackground src={mediaURL + item?.partImage} />
                                <BlackFilterBackground />
                                <PartItemDetails>

                                    <PartItemHeading>
                                        Session {index + 1}
                                    </PartItemHeading>

                                    <PartItemSubHeading>
                                        {item?.partTitle}
                                    </PartItemSubHeading>

                                </PartItemDetails>
                            </PartItemContainer>
                        )
                    })
                    }

                </PartsContainer>

            </ContentContainer>

        </MultiPartFeatureContainer >
    )
}

export default MultiPartCard;